import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router/dom';
import { Toaster } from '@/components/ui';
import { type Dictionary, I18nProvider, type Lang } from '@/i18n';
import { queryClient } from '@/lib/query';
import { router } from './router';
import { UpdatePrompt } from './UpdatePrompt';

export function App({ initialLang, initialDict }: { initialLang: Lang; initialDict: Dictionary }) {
  return (
    <I18nProvider initialLang={initialLang} initialDict={initialDict}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster />
        <UpdatePrompt />
      </QueryClientProvider>
    </I18nProvider>
  );
}
